import LearnHero from "../components/LearnHero";
import LearnDetails from "../components/LearnDetails";
import LearnIntro from "../components/LearnIntro";
import Fab from "@mui/material/Fab";
import { createPortal } from "react-dom";
import { useNavigate, useSearchParams } from "react-router-dom";
import SeoHead from "../components/seo/SeoHead";
import StructuredData from "../components/seo/StructuredData";
import Waves from "../blocks/Backgrounds/Waves/Waves";
import { COURSE_CATALOG } from "../data/courseCatalog";
import TheQAHubAcademyImage from "../images/TheQAHubAcademy.png";
import { useTranslation } from "../i18n";
import { breadcrumbSchema, courseListSchema, organizationSchema, schemaGraph } from "../utils/seoData";
import "./Learn.css";

function Learn() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const fromAcademy = searchParams.get("academy") === "1";

    return (
        <div className="learn-page">
            <SeoHead
                title="Aprende QA y testing | TheQAHub"
                description="Cursos, recursos y rutas para aprender Quality Assurance, testing y automatizacion de software con TheQAHub."
                canonicalPath="/aprende"
            />
            <StructuredData
                data={schemaGraph([
                    organizationSchema(TheQAHubAcademyImage),
                    courseListSchema(COURSE_CATALOG),
                    breadcrumbSchema([
                        { name: "Inicio", url: "/" },
                        { name: "Aprende", url: "/aprende" },
                    ]),
                ])}
            />
            {fromAcademy && typeof document !== "undefined" && createPortal(
                <Fab
                    color="primary"
                    onClick={() => navigate("/dashboard")}
                    aria-label="Volver a la academy"
                    title="Volver a la academy"
                    sx={{
                        position: "fixed",
                        right: { xs: 14, sm: 18 },
                        bottom: { xs: 14, sm: 18 },
                        width: 58,
                        height: 58,
                        minHeight: 58,
                        zIndex: 1400,
                        bgcolor: "#5f7868",
                        color: "#ffffff",
                        boxShadow: "0 18px 34px rgba(48, 64, 56, 0.24)",
                        border: "1px solid rgba(255,255,255,0.2)",
                        fontSize: "1.6rem",
                        fontWeight: 900,
                        "&:hover": {
                            bgcolor: "#44544c",
                        },
                    }}
                >
                    ↩
                </Fab>,
                document.body
            )}

            <LearnHero />

            <div className="waves-section">
                <Waves
                    lineColor="#97b79e"
                    backgroundColor="transparent"
                    waveSpeedX={0.02}
                    waveSpeedY={0.005}
                    waveAmpX={25}
                    waveAmpY={10}
                    xGap={12}
                    yGap={20}
                    className="custom-waves"
                />
                <p className="waves-text">{t("learn.waves")}</p>
            </div>

            <LearnIntro />

            <hr className="section-divider" />

            <LearnDetails />
        </div>
    );
}

export default Learn;
